import { useState } from "react";
import Table from "../../components/table/table";
import { TbDotsVertical } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import EditIcon from "../../icons/editIcon";
import DeleteIcon from "../../icons/deleteIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/dropDownMenu/dropdown-menu";
import Checkbox from "../../components/inputs/checkbox";
import { FaCheckSquare } from "react-icons/fa";
import { BsFillXSquareFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const StoreTable = ({ t, setOpenView, setOpenEdit, setOpenDelete }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const handleCheck = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleCheckAll = () => {
    if (selectedIds.length === products.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(products.map((m) => m.id));
    }
  };
  const handleClick = (m, setState) => {
    setState(true);
  };
  const navigate = useNavigate();
  const products = [
    {
      name: "قميص رياضي",
      category: "ملابس",
      price: "120 JD",
      quantity: 13,
      status: "متوفر",
    },
    {
      name: "مضرب تنس احترافي",
      category: "معدات رياضية",
      price: "250 JD",
      quantity: 0,
      status: "غير متوفر",
    },
    {
      name: "حذاء جري",
      category: "أحذية",
      price: "300 JD",
      quantity: 5,
      status: "متوفر",
    },
    {
      name: "نظارة سباحة",
      category: "معدات رياضية",
      price: "180 JD",
      quantity: 6,
      status: "غير متوفر",
    },
    {
      name: "قميص رياضي",
      category: "ملابس",
      price: "25 JD",
      quantity: 4,
      status: "متوفر",
    },
    {
      name: "قميص رياضي",
      category: "ملابس",
      price: "25 JD",
      quantity: 13,
      status: "غير متوفر",
    },
  ];

  const tableHead = [
    {
      header: (
        <Checkbox
          checked={selectedIds.length === products.length}
          onChange={handleCheckAll}
          id={"members-all"}
        />
      ),
      accessorKey: "check",
    },
    {
      header: t("productName"),
      accessorKey: "name",
    },
    {
      header: t("category1"),
      accessorKey: "category",
    },
    {
      header: t("price"),
      accessorKey: "price",
    },
    {
      header: t("quantity"),
      accessorKey: "quantity",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const tableData = products.map((m, i) => {
    const check = (
      <Checkbox
        checked={selectedIds.includes(m.id)}
        onChange={() => handleCheck(m.id)}
        id={`member-${i}`}
      />
    );
    const statusIcon =
      m.status === "متوفر" ? (
        <FaCheckSquare className="text-[#11A849]" />
      ) : (
        <BsFillXSquareFill className="text-[#902929]" />
      );

    const status = (
      <span className="flex items-center gap-1 mx-auto text-white w-fit">
        {statusIcon}
        {m.status}
      </span>
    );
    const actions = (
      <div className="relative mx-auto w-fit">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <TbDotsVertical />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenView)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("showDetails")}
                <IoEyeOutline size={24} />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => navigate(`/store/${i}`)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("editProduct")}
                <EditIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenDelete)}
                className="flex items-center gap-2 justify-end w-full text-[#FF5151] px-4 py-2 text-right hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("deleteProduct")}
                <DeleteIcon />
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
    return {
      check,
      name: m.name,
      category: m.category,
      price: m.price,
      status,
      quantity: m.quantity,
      actions,
    };
  });
  return <Table TableData={tableData} TableHead={tableHead} />;
};

export default StoreTable;
